import React from "react";
import classes from "./hero.module.css";
import Button from "../../containers/button/button";
// import Cloud from "../../../assets/images/cloud.png";
// import SummerLogo from "../../../assets/images/summer-logo.png";
import { useNavigate } from "react-router";
import { getImageUrl }  from "../../../utils/imageUrl";

const HeroSection = (props) => {
    const navigate = useNavigate();
    return (
        <div className={classes.Container}>
            {/* <div className={classes.DarkEffect} /> */}
            <div className={classes.Background} style={{ backgroundImage: `url(${getImageUrl(props.heroSection?.background_image)})` }}>
                <div>
                    <div className={classes.Images}>
                        {/* <img src={props.heroSection?.logo} alt="summer logo" /> */}
                        {/* <img src={Cloud} alt="cloud" /> */}
                        {/* <div /> */}
                    </div>
                    {/* <div className={classes.CloudContent}>
                        <div>{props.heroSection?.title}</div>
                        <div>Active until {props.heroSection?.active_until}</div>
                    </div> */}
                    {props.heroSection?.description
                        ?.split(/(?<!\w\.\w.)(?<![A-Z][a-z]\.)(?<=\.|\?)\s/) // Split after full stops or question marks
                        .map((sentence, index) => (
                            <p key={index}>{sentence}</p> 
                        ))}
                    <Button content={props.heroSection?.button_text} onClick={() => window.location.href = props.heroSection?.button_link} />
                </div>
            </div>
        </div>
    )
}

export default HeroSection;